module.exports = __webpack_public_path__ + "static/media/amber.c8c30968.jpg";